import Spinner from '@components/spinner/Spinner';
import { useVerifyUpdatedEmail } from '@hooks/putQueries';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { useMixpanel } from '../../context/MixpanelProvider';
import { AUTH_EVENTS } from '../../utils/eventSchema';

const VerifyEmailPage = () => {
  const { trackEvent, identifyUser, aliasUser } = useMixpanel();
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const token = urlParams.get('token');

  const navigate = useNavigate();

  const { mutateAsync: verifyEmail } = useVerifyUpdatedEmail(token);

  React.useEffect(() => {
    const validate = async () => {
      try {
        const res = await verifyEmail(token);

        if (res.email && res.user_id) {
          if (res.user_id) {
            // Step 1: Get the anonymous ID that was being tracked
            const anonymousId = mixpanel.get_distinct_id();

            // Step 2: Link anonymous user to permanent user ID
            aliasUser(anonymousId, res.user_id);

            // Step 3: Identify the user with their permanent attributes
            identifyUser(res.user_id, {
              email: res.email,
              $email: res.email,
              verified: true,
              email_verified_at: new Date().toISOString(),
            });

            // Step 4: Track the email verification event with user_id
            trackEvent('Auth', {
              ...AUTH_EVENTS.EMAIL_VERIFIED,
              user_id: res.user_id,
              email: res.user_email,
              verification_method: 'link',
              verified_at: new Date().toISOString(),
            });
          } else {
            // Fallback if no user_id is available
            trackEvent('Auth', {
              ...AUTH_EVENTS.EMAIL_VERIFIED,
              email: res.email,
              verification_method: 'link',
              verified_at: new Date().toISOString(),
            });
          }

          toast.success(`Email verified successfully, ${res.email}`, {
            toastId: 'email-verified-success',
          });
        }
      } catch (error) {
        toast.error(error?.detail, {
          toastId: 'email-verification-error',
        });
      } finally {
        setTimeout(() => {
          navigate('/signin');
        }, 2000);
      }
    };

    validate();
    return () => {};
  }, []);

  return <Spinner />;
};

export default VerifyEmailPage;
